<template lang="html">
  <div id="user-account-page" class="container oversized-container">
    <div class="row">

      <div class="col-lg col-sidebar" v-bind:class="{ 'active' : isMenuActive }">
        <button class="btn-sidebar-menu" @click="isMenuActive = !isMenuActive"><i class="fas fa-bars"></i></button>
        <div class="bg-sidebar-mobile" @click="isMenuActive = false;"></div>

        <div class="box-sidebar">
          <div class="box-welcome">
            <h5>Bienvenido</h5>
          </div>

          <div class="box-sidebar-menu">
            <router-link class="menu-item menu-home" :to="{ name: 'accHomePage' }" to="/dashboard">
              <div class="menu-txt">
                <i class="far fa-home-lg-alt icon"></i> <span class="txt">Inicio</span>
              </div>
            </router-link>

            <b-card class="menu-item">
              <b-card-header header-tag="header" role="tab">
                <div class="menu-txt" v-b-toggle.accordion-1>
                  <i class="far fa-user icon"></i> <span class="txt">Mi perfil</span>
                </div>
              </b-card-header>

              <b-collapse class="c-content" id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <router-link class="menu-item" :to="{ name: 'accPerfilDatosPage' }">
                    <div class="menu-txt">
                      <span class="txt">Datos generales</span>
                    </div>
                  </router-link>

                  <router-link class="menu-item" :to="{ name: 'accPerfilPuestosPage' }">
                    <div class="menu-txt">
                      <span class="txt">Histórico de puestos</span>
                    </div>
                  </router-link>

                  <router-link class="menu-item" :to="{ name: 'accPerfilAcademicaPage' }">
                    <div class="menu-txt">
                      <span class="txt">Información académica</span>
                    </div>
                  </router-link>

                  <router-link class="menu-item" :to="{ name: 'accPerfilFamilyPage' }">
                    <div class="menu-txt">
                      <span class="txt">Familia</span>
                    </div>
                  </router-link>

                  <router-link class="menu-item" :to="{ name: 'accPerfilFotoPage' }">
                    <div class="menu-txt">
                      <span class="txt">Mi foto</span>
                    </div>
                  </router-link>

                  <router-link class="menu-item" :to="{ name: 'accPerfilContrasenaPage' }">
                    <div class="menu-txt">
                      <span class="txt">Mi contraseña</span>
                    </div>
                  </router-link>

                </b-card-body>
              </b-collapse>
            </b-card>

            <router-link class="menu-item" :to="{ name: 'accPerfilCarreraPage' }">
              <div class="menu-txt">
                <i class="far fa-project-diagram icon"></i> <span class="txt">Plan de carrera</span>
              </div>
            </router-link>

            <router-link class="menu-item" :to="{ name: 'accBuzonPage' }">
              <div class="menu-txt">
                <i class="far fa-inbox icon"></i> <span class="txt">Ideas gente OZ</span>
              </div>
            </router-link>

            <router-link class="menu-item" :to="{ name: 'accBeneficiosPage' }">
              <div class="menu-txt">
                <i class="far fa-trophy icon"></i> <span class="txt">Beneficios de Grupo OZ</span>
              </div>
            </router-link>

            <router-link class="menu-item" :to="{ name: 'accVacacionesPage' }">
              <div class="menu-txt">
                <i class="far fa-calendar-star icon"></i> <span class="txt">Vacaciones</span>
              </div>
            </router-link>

            <b-card class="menu-item">
              <b-card-header header-tag="header" role="tab">
                <div class="menu-txt" v-b-toggle.accordion-2>
                  <i class="far fa-clipboard icon"></i> <span class="txt">Bolsa de trabajo</span>
                </div>
              </b-card-header>

              <b-collapse class="c-content" id="accordion-2" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <router-link class="menu-item" :to="{ name: 'accBolsaOfertasPage' }">
                    <div class="menu-txt">
                      <span class="txt">Vacantes</span>
                    </div>
                  </router-link>

                  <router-link class="menu-item" :to="{ name: 'accBolsaPostulacionesPage' }">
                    <div class="menu-txt">
                      <span class="txt">Postulaciones</span>
                    </div>
                  </router-link>
                </b-card-body>
              </b-collapse>
            </b-card>

            <router-link class="menu-item" :to="{ name: 'accPerMedicosPage' }">
              <div class="menu-txt">
                <i class="far fa-heart-rate icon"></i> <span class="txt">Permisos</span>
              </div>
            </router-link>

            <!-- <router-link class="menu-item" :to="{ name: 'accCapacitacionesPage' }">
              <div class="menu-txt">
                <i class="far fa-certificate icon"></i> <span class="txt">Capacitaciones</span>
              </div>
            </router-link> -->

            <b-card class="menu-item">
              <b-card-header header-tag="header" role="tab">
                <div class="menu-txt" v-b-toggle.accordion-4>
                  <i class="far fa-certificate icon"></i> <span class="txt">Capacitaciones</span>
                </div>
              </b-card-header>

              <b-collapse class="c-content" id="accordion-4" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <router-link class="menu-item" :to="{ name: 'accCapacitacionesPage' }">
                    <div class="menu-txt">
                      <span class="txt">Listado de capacitaciones</span>
                    </div>
                  </router-link>

                  
                  <router-link class="menu-item" :to="{ name: 'accOnJobTrainingPage' }">
                    <div class="menu-txt">
                      <span class="txt">On Job Training</span>
                    </div>
                  </router-link>

                  
                </b-card-body>
              </b-collapse>
            </b-card>




            <b-card class="menu-item">
              <b-card-header header-tag="header" role="tab">
                <div class="menu-txt" v-b-toggle.accordion-3>
                  <i class="far fa-chart-bar icon"></i> <span class="txt">Evaluaciones</span>
                </div>
              </b-card-header>

              <b-collapse class="c-content" id="accordion-3" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <router-link class="menu-item" :to="{ name: 'accCualitativaPage' }">
                    <div class="menu-txt">
                      <span class="txt">Cualitativa</span>
                    </div>
                  </router-link>

                  <router-link class="menu-item" :to="{ name: 'accCuantitativaPage' }">
                    <div class="menu-txt">
                      <span class="txt">Cuantitativa</span>
                    </div>
                  </router-link>
       
                  
                </b-card-body>
              </b-collapse>
            </b-card>


            <router-link class="menu-item" :to="{ name: 'accPoliticasPage' }">
              <div class="menu-txt">
                <i class="far fa-book icon"></i> <span class="txt">Políticas y reglamentos</span>
              </div>
            </router-link>

            <router-link class="menu-item" :to="{ name: 'accComuPage' }">
              <div class="menu-txt">
                <i class="far fa-newspaper icon"></i> <span class="txt">Comunicados</span>
              </div>
            </router-link>

            <a class="menu-item" @click="handleLogout()" >
              <div class="menu-txt">
                <i class="far fa-sign-out icon"></i> <span class="txt">Salir</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="col-lg col-content">
        <div class="box-dynamic-content">
          <router-view></router-view>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuActive: false,
    }
  },

  watch:{
    '$route' (to, from){
      this.isMenuActive = false;
    }
  },
  methods: {
    handleLogout(){
            axios.post(tools.url("/api/logout")).then((response)=>{
                this.$root.user = null;
                this.$root.logged = false;
                this.$router.push('/');
            }).catch(()=>{});
    }

  },
}
</script>
